// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.container {
  padding: 0px 20px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

ion-row.row-btn-delete ion-button {
  font-size: 18px;
}
ion-row.row-btn-delete ion-button::part(native) {
  padding: 0px;
}

ion-grid.form-product {
  --ion-padding: 20px;
  border-radius: 20px;
  background: white;
  box-shadow: 0px 0px 40px -5px var(--ion-color-primary);
}
ion-grid.form-product ion-item {
  --background: white;
}
ion-grid.form-product ion-row {
  padding: 0px 20px;
}
ion-grid.form-product p {
  color: var(--ion-color-primary);
}
ion-grid.form-product p.category {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 0px;
}
ion-grid.form-product p.desc-short {
  font-weight: bold;
  font-size: 30px;
  margin: 0px;
}
ion-grid.form-product p.desc-long {
  font-size: 24px;
  margin: 0px;
}
ion-grid.form-product p.prices {
  font-size: 26px;
  margin: 0px;
  margin-bottom: 5px;
}
ion-grid.form-product p.prices fa-icon {
  margin-right: 5px;
}
ion-grid.form-product ion-item.total-row {
  padding-left: 0px;
}
ion-grid.form-product ion-item.total-row ion-label {
  font-weight: bold;
  font-size: 30px !important;
}
ion-grid.form-product .btn-select {
  margin: 0px;
  max-width: 50px;
  height: 100%;
  --border-radius: 10px;
}
ion-grid.form-product ion-col.ion-col-trash {
  display: grid;
  justify-content: center;
  align-items: center;
}
ion-grid.form-product ion-col.ion-col-numpad {
  justify-content: space-evenly;
  display: flex;
  align-items: center;
}
ion-grid.form-product ion-col.ion-col-numpad h2 {
  margin: 10px auto;
  font-size: 24px;
  font-weight: bold;
}
ion-grid.form-product ion-col.ion-col-numpad .btn-qty {
  max-width: 45px;
  height: 45px;
  --border-radius: 10px;
}
ion-grid.form-product ion-row.input-qty ion-col:nth-last-child(2) {
  max-width: 200px;
}
ion-grid.form-product ion-row.input-qty ion-col:last-of-type {
  max-width: 200px;
}
ion-grid.form-product ion-row.input-qty ion-col:last-of-type div {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
ion-grid.form-product ion-row.row-btn-accessories ion-col {
  text-align: center;
}
ion-grid.form-product ion-row.row-btn-accessories ion-col ion-button {
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/form/quotation/product/quotation-product/quotation-product.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EAEA,aAAA;EACA,mBAAA;EAEA,mBAAA;AADJ;;AAMI;EACI,eAAA;AAHR;AAMI;EACI,YAAA;AAJR;;AASA;EAEI,mBAAA;EAGA,mBAAA;EAGA,iBAAA;EAIA,sDAAA;AAdJ;AAgBI;EACI,mBAAA;AAdR;AAiBI;EACI,iBAAA;AAfR;AAkBI;EACI,+BAAA;AAhBR;AAoBI;EACI,iBAAA;EAEA,eAAA;EAEA,kBAAA;AApBR;AAuBI;EACI,iBAAA;EAEA,eAAA;EAEA,WAAA;AAvBR;AA0BI;EACI,eAAA;EAEA,WAAA;AAzBR;AA4BI;EAEI,eAAA;EAEA,WAAA;EAEA,kBAAA;AA7BR;AA+BQ;EACI,iBAAA;AA7BZ;AAiCI;EAEI,iBAAA;AAhCR;AAkCQ;EACI,iBAAA;EACA,0BAAA;AAhCZ;AAoCI;EAEI,WAAA;EAEA,eAAA;EACA,YAAA;EAEA,qBAAA;AArCR;AAwCI;EAMQ,aAAA;EAEA,uBAAA;EAEA,mBAAA;AA7CZ;AAiDI;EAII,6BAAA;EAEI,aAAA;EAIA,mBAAA;AAtDZ;AA6DQ;EACI,iBAAA;EACA,eAAA;EACA,iBAAA;AA3DZ;AA8DQ;EAEI,eAAA;EACA,YAAA;EAEA,qBAAA;AA9DZ;AAyEQ;EACI,gBAAA;AAvEZ;AA2EQ;EAEI,gBAAA;AA1EZ;AA4EY;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AA1EhB;AAoFQ;EACI,kBAAA;AAlFZ;AAoFY;EACI,eAAA;AAlFhB","sourcesContent":["div.container{\n    padding: 0px 20px;\n    // padding-left: 0px;\n    display: flex;\n    align-items: center;\n\n    margin-bottom: 10px;\n}\n\nion-row.row-btn-delete{\n\n    ion-button{\n        font-size: 18px;\n    }\n\n    ion-button::part(native){\n        padding: 0px;\n    }\n\n}\n\nion-grid.form-product {\n\n    --ion-padding: 20px;\n\n    // border:2px solid var(--ion-color-primary);\n    border-radius: 20px;\n\n    \n    background: white;//var(--ion-card-background, var(--ion-item-background, var(--ion-background-color, #fff)));\n    // --color: var(--ion-card-color, var(--ion-item-color, var(--ion-color-step-550, #737373)));\n    // margin: 10px;\n\n    box-shadow: 0px 0px 40px -5px var(--ion-color-primary);\n\n    ion-item{\n        --background: white;\n    }\n\n    ion-row{\n        padding: 0px 20px;\n    }\n\n    p{\n        color: var(--ion-color-primary);\n    }\n\n    \n    p.category{\n        font-weight: bold;\n\n        font-size: 14px;\n\n        margin-bottom: 0px;\n    }\n\n    p.desc-short{\n        font-weight: bold;\n\n        font-size: 30px;\n\n        margin: 0px;\n    }\n\n    p.desc-long{\n        font-size: 24px;\n\n        margin:0px;\n    }\n\n    p.prices{\n        \n        font-size: 26px;\n\n        margin: 0px;\n\n        margin-bottom: 5px;\n\n        fa-icon{\n            margin-right: 5px;\n        }\n    }\n\n    ion-item.total-row {\n\n        padding-left: 0px;\n\n        ion-label{\n            font-weight: bold;\n            font-size: 30px !important;\n        }\n    } \n\n    .btn-select{\n\n        margin: 0px;\n\n        max-width:50px;\n        height:100%;\n\n        --border-radius: 10px;\n    }\n\n    ion-col.ion-col-trash{\n\n        // display: flex;\n\n        // justify-content: space-evenly;\n        \n            display: grid;\n    \n            justify-content: center;\n\n            align-items: center;\n\n    }\n\n    ion-col.ion-col-numpad{\n\n        // display: flex;\n\n        justify-content: space-evenly;\n        \n            display: flex;\n    \n            // justify-content: end;\n\n            align-items: center;\n        \n            // .container-qty{\n            \n        // }\n\n\n        h2{\n            margin: 10px auto;\n            font-size: 24px;\n            font-weight: bold;\n        }\n\n        .btn-qty{\n\n            max-width:45px;\n            height:45px;\n\n            --border-radius: 10px;\n        }\n\n\n    }   \n \n\n\n    ion-row.input-qty {\n\n        // penultima colonna\n        ion-col:nth-last-child(2) {\n            max-width: 200px;\n        }\n\n        // ultima colonna\n        ion-col:last-of-type {             \n\n            max-width: 200px;\n\n            div {\n                height: 100%;\n                width: 100%;\n                display: flex;\n                align-items: center;\n                justify-content: flex-end;\n            }\n            \n        }\n\n        \n    }\n\n    ion-row.row-btn-accessories{\n\n        ion-col{\n            text-align: center;\n\n            ion-button{\n                font-size: 16px;\n            }\n\n        }\n\n    }\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
